import { render } from "./Angpao.vue?vue&type=template&id=5400e9a4"
import script from "./Angpao.vue?vue&type=script&lang=js"
export * from "./Angpao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__